<script>
  export let course;
  export let cardHeight;
 // export let textSize;
 
  export let textSize = "text-xl.5";

//font sizes
let textSizeCSS = {
    "text-xs": "text-xs",
    "text-sm": "text-sm",
    "text-base": "text-base",
    "text-lg": "text-lg",
    "text-xl": "text-xl",
    "text-2xl": "text-2xl",
    "text-3xl": "text-3xl",
    "text-4xl": "text-4xl"
};

$: renderedTextSize = textSizeCSS[textSize] || "text-xl.5";

     // title case function
  function toTitleCase(str) {
      if (!str) return '';
      return str
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .trim()
          .replace(/\b\w/g, c => c.toUpperCase());
  }



</script>

<!-- Main container for the grid -->
<div class=" snap-center sm:snap-align-none testmonial-card tz-0 rounded-2xl overflow-hidden relative transition-transform duration-300 h-[380px]" style="height:{cardHeight}px">
  <a href="{course.url}" class="flex w-[290px] h-[380px] gtm-teacher-anchor" style="height:{cardHeight}px">
  <!-- <img width="285" height="380" src="{course.user_image}" class="object-cover h-full w-full" loading="lazy"  style="height:{cardHeight}px"/> -->
  {#if course.user_image} 
  <img width="285" height="380" src="{course.user_image}" class="object-cover h-full w-full" loading="lazy"  style="height:{cardHeight}px"/>
  {:else}
  <img width="285" height="380" src="/app/plugins/elementor_artofliving/assets/img/place-holder-teacher.svg" class="object-cover h-full w-full" loading="lazy"  style="height:{cardHeight}px"/>
  {/if}
  <div class="absolute w-full h-full top-0 rounded-2xl block bg-gradient-to-b from-transparent via-transparent to-pm-realblack z-[100]">
    <div class="absolute bottom-0 p-3">
        <p class="w-full {renderedTextSize} font-bold text-pm-white profession mb-0 capitalize">
          <!-- {course.first_name} {course.last_name} -->
          {toTitleCase(course.first_name)} {toTitleCase(course.last_name)}
      </p>
      <!-- <p class="w-full text-lg text-pm-white profession mb-0">Happiness Program, Online...</p> -->
    </div>
  </div>
  </a>
</div>
